/** Aligned with bildit-web-nextjs `app/lib/marketing-pixel-config.ts`. */

export const GTM_CONTAINER_ID = 'GTM-K6K5NGJB';

export const GA_MEASUREMENT_ID = 'G-9KVM2B58MK';

export const GOOGLE_ADS_ID = 'AW-1066122834';

/** LinkedIn Insight Tag conversion id for lead form submits (bildit-web HubSpot modules). */
export const LINKEDIN_LEAD_FORM_CONVERSION_ID = '9079353';

/**
 * Contentsquare UX Analytics (session replay / heatmaps; Hotjar is part of Contentsquare).
 * @type {string}
 */
export const CONTENTSQUARE_SCRIPT_URL =
  'https://t.contentsquare.net/uxa/c73d11500e300.js';

/** Primary "Submit lead form" conversion from bildit-web HubSpot modules. */
export const LEAD_FORM_CONVERSION_LABEL = '2P9_CKDisLkbENL8rvwD';

/** Contentsquare dynamic variable for lead form submits (bildit-web HubSpot modules). */
export const CONTENTSQUARE_FORM_SUBMIT_VARIABLE_ID = 1;

export const CONTENTSQUARE_FORM_SUBMIT_VARIABLE_VALUE = 'form_submit';

/** OpenAI ChatGPT Ads measurement pixel id (Conversions tab in Ads Manager). */
export const OPENAI_PIXEL_ID =
  process.env.REACT_APP_OPENAI_PIXEL_ID || 'L2a7usxfScgSJp3G2mv9Mo';
